import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';

import { Discount } from '../../../types/discount.interface';

@Component({
	selector: 'app-discount-block',
	templateUrl: './discount-block.component.html',
	styleUrls: ['./discount-block.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DiscountBlockComponent {
	@Input() discount: Discount;

	@Output() updateDiscountModal = new EventEmitter();

	public confirmText;

	constructor(
		private ms: ModalService,
	) { }

	emitDiscount(discount) {
		this.updateDiscountModal.emit(discount);
	}

	openUrl(discount) {
		window.open(`${discount.redemptionUrl}`, '_blank');
	}
}
